/**
 * Admin 게시글 승인. 라우트 admin.php post-approvals 그룹과 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

export const PostApprovalController = {
    index(): void {
        noop("PostApprovalController", "index");
    },
    approve(): void {
        noop("PostApprovalController", "approve");
    },
    reject(): void {
        noop("PostApprovalController", "reject");
    },
};
